import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';

class ModalAlert extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.showModal
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            isOpen: newProps.showModal
        });
    }

    toggleModal() {
        if(this.state.isOpen) {
            //notify parent that modal is closed
            this.props.closeModalHandler();
        }
        else {
            this.setState({isOpen: !this.state.isOpen});
        }
    }

    render() {
        var message = this.props.message;
        if(message === null || message === "")
        {
            return null;
        }

        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggleModal} centered={true}>
                <ModalHeader toggle={this.toggleModal}>
                    <h3> <span className="fa fa-exclamation-triangle"> </span> </h3>
                </ModalHeader>
                <ModalBody>
                    <h3> {message} </h3>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalAlert;
